import { render, staticRenderFns } from "./archiveDrivers.vue?vue&type=template&id=ceab8798&"
import script from "./archiveDrivers.vue?vue&type=script&lang=js&"
export * from "./archiveDrivers.vue?vue&type=script&lang=js&"
import style0 from "./archiveDrivers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports